import { render } from "./PageSelector.vue?vue&type=template&id=2aac3b0b&scoped=true"
import script from "./PageSelector.vue?vue&type=script&lang=js"
export * from "./PageSelector.vue?vue&type=script&lang=js"

import "./PageSelector.vue?vue&type=style&index=0&id=2aac3b0b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aac3b0b"]])

export default __exports__